import React from "react";
import "./uploadNavMob.css";
import { useUploadModal } from "../../context/UploadModalContext";
const UploadNavMob: React.FC = () => {
  const { openUploadMobileModal } = useUploadModal();
  return (
    <div className="upload-mob-nav bg-white border-top shadow-sm d-block d-md-none">
      <div className="container px-3 py-2 d-flex justify-content-between align-items-center flex-column gap-3">
        <div
          className="d-flex align-items-center justify-content-between text-primary fw-medium w-100 border-bottom pb-2"
          onClick={openUploadMobileModal}
          role="button"
        >
          <div>
            <svg
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.615 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H11C11.5304 1 12.0391 1.21071 12.4142 1.58579C12.7893 1.96086 13 2.46957 13 3V11"
                stroke="#6E42E5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 16L12 18L16 14"
                stroke="#6E42E5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 5H9"
                stroke="#6E42E5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 9H7"
                stroke="#6E42E5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="ms-2">View All Applicants</span>
          </div>
          <div>
            <svg
              width="14"
              height="9"
              viewBox="0 0 14 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 7.5L7 1.5L13 7.5"
                stroke="#676767"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* <button className="btn bg-primary text-white fw-semibold px-4 py-3 w-100">
          CONTINUE
        </button> */}
      </div>
    </div>
  );
};

export default UploadNavMob;
